import styled from "styled-components";

export const MemberSearchListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const MemberSearchListHeader = styled.div`
  display: flex;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  text-align: center;
  padding: 0 15px;
  gap: 5px;

  > div {
    flex: 1;
  }
`;

export const MemberSearchListBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const MemberSearchListItem = styled.div`
  display: flex;
  background: #ecf0f3;
  width: 100%;
  height: 45px;
  border-radius: 15px;
  padding: 10px 15px;
  box-sizing: border-box;
  align-items: center;
  gap: 5px;

  font-family: Pretendard;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #121212;
  cursor: pointer;

  &:hover {
    background: rgb(215, 221, 226);
  }

  > div {
    flex: 1;
  }
`;
